// assets/printale-transitions.js
// Global cinematic film-leader countdown for ALL internal navigation.
// Loaded on every page. No sound — sound is added by the homepage module
// via the 'printale:navigate-start' CustomEvent.

const OVERLAY_ID = 'cinema-leader-countdown';
const NUMBER_ID = 'cinema-leader-number';

/**
 * Returns true if href should trigger the countdown transition.
 * Excludes: empty, hash, javascript:, mailto:, tel:, external domains.
 */
export function isInternalHref(href) {
  if (!href) return false;
  if (href.startsWith('#')) return false;
  if (href.startsWith('javascript:')) return false;
  if (href.startsWith('mailto:')) return false;
  if (href.startsWith('tel:')) return false;
  // Absolute URL to another domain
  if (/^https?:\/\//.test(href) && !href.includes(window.location.hostname)) return false;
  return true;
}

/**
 * Returns true if href resolves to the page the user is already on.
 * Prevents a self-navigation loop.
 */
export function isSamePage(href) {
  try {
    const target = new URL(href, window.location.href);
    return (
      target.pathname === window.location.pathname &&
      target.search === window.location.search
    );
  } catch {
    return false;
  }
}

function runCountdown(overlay, numberEl, href) {
  overlay.classList.add('active');
  let count = 3;
  if (numberEl) numberEl.textContent = count;

  const interval = setInterval(() => {
    count--;
    if (count > 0) {
      if (numberEl) numberEl.textContent = count;
      document.dispatchEvent(new CustomEvent('printale:navigate-tick'));
    } else {
      clearInterval(interval);
      const burn = overlay.querySelector('.cinema-leader-countdown__burn');
      if (burn) burn.classList.add('active');
      setTimeout(() => { window.location.href = href; }, 400);
    }
  }, 400);
}

export function initTransitions() {
  const overlay = document.getElementById(OVERLAY_ID);
  const numberEl = document.getElementById(NUMBER_ID);

  document.querySelectorAll('a').forEach((link) => {
    const href = link.getAttribute('href');
    if (!isInternalHref(href) || isSamePage(href)) return;

    link.addEventListener('click', (e) => {
      e.preventDefault();
      // Notify other modules (homepage effects listens for sound)
      document.dispatchEvent(new CustomEvent('printale:navigate-start'));

      if (!overlay) {
        window.location.href = href;
        return;
      }
      runCountdown(overlay, numberEl, href);
    });
  });
}

// Auto-boot
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTransitions, { once: true });
} else {
  initTransitions();
}
